<template>
  <div class="modal-container" tabindex="0" @click="handleClick" @keyup.esc="$emit('triggerCloseModal')">
    <div class="division-modal" ref="modal">
      <div class="division-main-section" v-if="section === 1">
        <div class="modal-section-title">{{ `Potrero - ${division.id}` }}</div>
        <div class="d-flex justify-content-center align-items-center gap-2 pb-3">
          <numbersInput :type="'text'" :placeholder="0" :class-name="'size-input'" :value="size"
            v-on:change="changeSize" /> 
          <!-- <span class="h3">
            Has.
          </span> -->
        <span> 
          Has.
        </span>
        </div>
        <ErrorMessage v-if="error.length" :text="error" />
        <div class="button-container">
          <button v-if="this.currentPlanData.divisions.length > 1" class="btn delete-btn" @click="deleteDivision">Eliminar
            potrero</button>
          <button class="btn confirm-btn" @click="handleChangeSize">OK</button>
          <button class="btn secondary-btn" @click="this.section = this.section + 1">
            {{ division?.product?._id ? 'Seleccionar otra semilla' : 'Seleccionar semilla' }}
          </button>
        </div>
      </div>
      <div class="division-main-section" v-else>
        <div class="modal-section-title">¿Qué va a sembrar en el Potrero {{ division.id }}?</div>
        <div class="product-container">
          <individualProduct v-for="product in this.products" :key="product._id" :product="product" :division="division"
            @click="selectedProduct = product" @productSelected="handleSelectProduct" />
        </div>
        <div class="button-container">
          <button class="btn secondary-btn" @click="this.section = this.section - 1">
            Volver
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorMessage from './errorMessage.vue';
import { mapState, mapActions } from 'pinia'
import planStore from '../store/plan'
import individualProduct from "./individualProduct.vue"
import numbersInput from './numbersInput.vue';
export default {
  name: 'division-modal',
  props: {
    divisionData: Object,
    products: Array
  },
  data() {
    return {
      section: 1,
      division: this.divisionData,
      error: '',
      selectedProduct: {},
      size: 0,
      otherDivision: {}
    }
  },
  mounted() {
    this.size = this.divisionData.sizeInHectares.toFixed(0)
  },
  methods: {
    ...mapActions(planStore, ['updateCurrentPlanData', 'getWidthInPercentage']),
    handleClick(e) {
      if (!this.$refs.modal?.contains(e.target) && e.target.classList[0] !== 'btn') {
        this.$emit('triggerCloseModal')
      }
    },
    changeSize(event) {
      this.size = parseInt(event.target.value);
    },
    async handleDeleteDivisionFromPinia(hectares, percentage) {
      this.otherDivision.sizeInHectares += hectares
      this.otherDivision.widthInPercentage += percentage
      await this.updateCurrentPlanData({ id: this.division.id }, 'deleteDivision')
    },
    deleteDivision() {
      if (this.currentPlanData.divisions.length === 1) {
        this.error = "No puedes eliminar el ultimo potrero"
        return;
      }
      const { sizeInHectares, widthInPercentage, id } = this.division

      if (this.currentPlanData.divisions.length === 2) {
        this.otherDivision = this.currentPlanData.divisions.find((d) => d.id != id)

        this.handleDeleteDivisionFromPinia(sizeInHectares, widthInPercentage)
        this.otherDivision.id = 1
        // Just delete the other one and whichever is left must be the first one
      } else {
        const deleteFromTheBeginning = this.currentPlanData.divisions.length === 3 && (id === 1 || id === 2) || this.currentPlanData.divisions.length === 4 && (id === 1 || id === 2 || id === 3)

        const deleteLast = this.currentPlanData.divisions.length === 3 && id === 3 || this.currentPlanData.divisions.length === 4 && id === 4

        if (deleteFromTheBeginning) {
          this.otherDivision = this.getOtherDivision(id + 1)
          this.handleDeleteDivisionFromPinia(sizeInHectares, widthInPercentage)

          this.afterDelete()
          // always reassign order with a basic id in this case
        } else if (deleteLast) {
          this.otherDivision = this.getOtherDivision(id - 1)
          this.handleDeleteDivisionFromPinia(sizeInHectares, widthInPercentage)
        }
      }

      this.$emit('triggerCloseModal')
    },
    getOtherDivision(target) {
      return this.currentPlanData.divisions.find((d) => d.id === target)
    },
    afterDelete() {
      for (let i = 0; i < this.currentPlanData.divisions.length; i++) {
        const division = this.currentPlanData.divisions[i];
        division.id = i + 1
      }
    },
    isPositive(num) {
      if (num > 0) {
        return true
      } else return false
    },
    async handleChangeSize() {
      this.error = ""

      let difference = this.size - this.division.sizeInHectares

      if (this.size === 0) {
        this.error = "Por favor ingrese un valor válido"
        return;
      }

      if (this.size >= this.currentPlanData.totalSize) {
        // If the size the user inputted is bigger than the plan's totalSize
        // Then there should be only one division left and update the plan's totalSize
        this.overwriteTotalSizeWithDivision()
        this.afterDelete()
        this.$emit('triggerCloseModal')
        return;
      }

      if (this.currentPlanData.divisions.length === 1) {
        // If there's only one division totalSize should be updated instead
        await this.updateCurrentPlanData(this.size, 'totalSize')

        await this.updateCurrentPlanData([{
          ...this.division,
          sizeInHectares: this.size,
        }], 'divisions')
      } else if (this.currentPlanData.divisions.length === 2) {
        this.resizeBetweenTwoDivisions(difference)
      } else {
        const isLastDiv = this.currentPlanData.divisions.length === 3 && this.division.id === 3 || this.currentPlanData.divisions.length === 4 && this.division.id === 4
        const isFirstDiv = this.division.id === 1
        /*
          This algorithm behaves in three predictable ways. 
          When resizing, it'll always look to the right division to take up or give size in hectares
          If it has to take up enough space to delete a whole division, it will.
          If it doesn't have enough space to the right, it'll look to the left side
        */
        if (isFirstDiv) {
          this.resize(difference, 'start')
        } else if (isLastDiv) {
          this.resize(difference, 'end')
        } else {
          this.resize(difference, 'middle')
        }
      }

      this.$emit('triggerCloseModal')
    },
    async resize(difference, key) {
      const getCorrespondingOtherDivision = () => {
        // Get the other division I'm going to interact with
        // Always look to the right when possible, else look to the left
        if (key === 'start') {
          this.otherDivision = this.getOtherDivision(this.division.id + 1)
        } else if (key === 'end') {
          this.otherDivision = this.getOtherDivision(this.division.id - 1)
        } else {
          // is middle
          this.otherDivision = this.getOtherDivision(this.division.id + 1)
          if (!this.otherDivision) this.otherDivision = this.getOtherDivision(this.division.id - 1)
        }
      }
      if (this.isPositive(difference)) {
        // Meaning user wants to make the target division bigger
        // while difference > 0 check if you have to delete a division or can take size from it without deleting it
        while (difference) {
          getCorrespondingOtherDivision();
          if (this.otherDivision.sizeInHectares - difference > 0) {
            // Check if you can take space from it without deleting it
            this.updateSize(this.division, this.otherDivision, difference)
            difference = 0;
          } else {
            // Absorb size from the next one and check if you have to delete another one again
            const { sizeInHectares, widthInPercentage, id } = this.otherDivision
            this.division.sizeInHectares += sizeInHectares
            this.division.widthInPercentage += widthInPercentage
            await this.updateCurrentPlanData({ id }, 'deleteDivision')
            this.afterDelete();
            difference -= sizeInHectares;
          }
        }
      } else {
        getCorrespondingOtherDivision();
        this.updateSize(this.division, this.otherDivision, difference)
      }
    },
    resizeBetweenTwoDivisions(difference) {
      this.otherDivision = this.currentPlanData.divisions.find((d) => d.id != this.division.id)
      this.updateSize(this.division, this.otherDivision, difference)
    },
    async overwriteTotalSizeWithDivision() {
      await this.updateCurrentPlanData(this.size, 'totalSize')

      await this.updateCurrentPlanData([{
        ...this.division,
        sizeInHectares: Math.round(this.size),
        widthInPercentage: 100,
        id: 1
      }], 'divisions')
    },

    updateSize(selectedDivision, otherDivision, difference) {
      selectedDivision.sizeInHectares = selectedDivision.sizeInHectares + difference
      otherDivision.sizeInHectares = otherDivision.sizeInHectares + (difference * - 1)
      selectedDivision.widthInPercentage = this.getWidthInPercentage(this.currentPlanData.totalSize, selectedDivision.sizeInHectares)
      otherDivision.widthInPercentage = this.getWidthInPercentage(this.currentPlanData.totalSize, otherDivision.sizeInHectares)
    },
    async handleSelectProduct(product) {
      const { color, icon, name, price, season, _id } = product
      let productObject = { color, icon, name, price, season, _id }
      this.division.product = productObject
      let data = {
        product: {
          season: product.season,
          name: product.name,
          id: product._id
        },
        divisionId: this.division.id,
        size: this.division.sizeInHectares,
      }
      await this.updateCurrentPlanData(data, 'selectProduct')
      // GasoilId is always the same
      // Handle select season from here as well
      this.$emit('triggerCloseModal')
    },
  },
  computed: {
    ...mapState(planStore, ['currentPlanData']),
    disableButton() {
      return this.size === this.divisionData.sizeInHectares
    }
  },
  components: {
    individualProduct,
    ErrorMessage,
    numbersInput
  }
}
</script>

<style scoped>
.product {
  width: 6rem !important;
  height: 6rem !important;
}

.product-container {
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.modal-section-title {
  display: flex;
  justify-content: center;
  text-align: center;
  /* font-size: 2.7rem; */
  font-size: 1.8rem;
}

.division-main-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 80%;
}

.btn {
  width: 15rem;
  height: 2.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-btn {
  /* font-size: 1.5rem; */
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}

.confirm-btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}

.secondary-btn {
  /* make unique later */
  font-size: 1rem;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid #d6a02d;
  transition: all 0.3s;
}

.secondary-btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}

.delete-btn {
  /* make unique later */
  font-size: 1rem;
  color: var(--alert-button);
  background-color: var(--white);
  border: 1px solid var(--alert-button);
  border-radius: var(--main-border-radius);
  padding: 1.375rem 2.125rem 1.375rem 2.125rem;
  border: 0.125rem solid var(--alert-button);
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  /* gap: 1rem */
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 8rem;  
}

.delete-btn:hover {
  background-color: #cec600;
  background-color: transparent;
  color: #14bf98;
  color: #d6a02d;
  text-decoration: none;
  border: 0.125rem solid #d6a02d;
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
}

.size-input {
  border: 2px solid var(--dark-gray);
  width: 20rem;
  height: 3rem;
  padding: 1rem;
  text-align: center;
  font-size: 2rem;
}

.division-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 55rem;
  width: 85%;
  height: 23rem;
  background-color: white;
  z-index: 1;
  border-radius: var(--main-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}

.modal-container {
  width: 100%;
  height: 100%;
  background-color: #d9d9d9db;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
}

input[type="number"]::-webkit-inner-spin-button {
  display: none;
}

@media screen and (max-width: 700px) {

  .modal-section-title {
    font-size: 1.2rem;
    width: 70%;
  }

  .button-container {
    width: 80%;
    gap: 1.5rem;
  }

  .confirm-btn {
    width: 30%;
    /* display: inline-block; */
    /* padding: 1.375rem 2.125rem 1.375rem 2.125rem; */
    border-radius: 0.75rem;
    font: 500 1.00rem/0 "Roboto", sans-serif;
  }

  .secondary-btn {
    width: 70%;
    /* display: inline-block; */
    /* padding: 1.375rem 2.125rem 1.375rem 2.125rem; */
    border-radius: 0.75rem;
    font: 500 1.00rem "Roboto", sans-serif;
  }

  .size-input {
  border: 2px solid var(--dark-gray);
  width: 70%;
  height: 2.4rem;
  padding: 1rem;
  text-align: center;
  font-size: 1.2rem;
  }


  .product {
    width: 2.7rem !important;
    height: 2.7rem !important;
  }

  .product-container {
    width: 92%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .delete-btn {
    width: 5rem;
  }





}
</style>